import emptyGuidebook from '../../events/guidebook/empty-guidebook';
import { guidebookActionCreator } from '../../events/guidebook/guidebook';

const { resetTo } = guidebookActionCreator;

const clearGuidebook = () => dispatch => dispatch(resetTo(emptyGuidebook));

export default clearGuidebook;
